import { AuthService } from "./auth.service";

export const services: any[] = [AuthService];

export * from "./auth.service";
